var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcenaFinansijskihIzvestaja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "30px",
    height: "30px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "39. Mind",
    id: "_39._Mind"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.87,12.07a14.1,14.1,0,0,0-12-12A14,14,0,0,0,4.08,12.61l-4,7.94a1,1,0,0,0,.34,1.28L3,23.54V31a1,1,0,0,0,1,1H25a1,1,0,0,0,1-1,13.66,13.66,0,0,1,3.05-8.38A13.93,13.93,0,0,0,31.87,12.07Zm-4.4,9.29A15.79,15.79,0,0,0,24,30h-7.4a8.76,8.76,0,0,0,1.56-1.6l.6-.8a1,1,0,1,0-1.6-1.2l-.6.8A7,7,0,0,1,11,30H5V23a1,1,0,0,0-.45-.83L2.29,20.66l3.42-6.85A1,1,0,0,0,6,13.14a12,12,0,1,1,21.43,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,4A10,10,0,1,0,28,14,10,10,0,0,0,18,4Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,18,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,11h2a1,1,0,0,0,0-2H19a1,1,0,0,0-2,0v.18A3,3,0,0,0,18,15a1,1,0,0,1,0,2H16a1,1,0,0,0,0,2h1a1,1,0,0,0,2,0v-.18A3,3,0,0,0,18,13a1,1,0,0,1,0-2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcenaFinansijskihIzvestaja);
export default __webpack_public_path__ + "static/media/ProcenaFinansijskihIzvestaja.f6847209ec6c2b7900b63c7ed7203e73.svg";
export { ForwardRef as ReactComponent };